export class NumericFilter {
    constructor(params) {
        this.operator = params.operator;
        this.value = params.value;
        this.endValue = params.endValue;
    }
}
